import { getFontSize, getColorAlias } from '../../../../utils/index.js';
import styled, { css } from 'styled-components';
import { ListItemSecondaryText } from '../ListItemContent/styles.js';

const sharedSuffixPositioning = css `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
const ListItemMetaText = styled(ListItemSecondaryText) `
  ${sharedSuffixPositioning}
  align-self: baseline;
  ${getFontSize('size14')};
`;
const ListItemSuffixWrapper = styled.div `
  ${sharedSuffixPositioning}
  flex-basis: 25%;

  & > svg {
    ${getFontSize('size24')};
    fill: ${getColorAlias('interactivePrimary')};
  }
`;

export { ListItemMetaText, ListItemSuffixWrapper };
